import { render } from "./Coaches.vue?vue&type=template&id=2d0854ee"
import script from "./Coaches.vue?vue&type=script&lang=js"
export * from "./Coaches.vue?vue&type=script&lang=js"

import "./Coaches.vue?vue&type=style&index=0&id=2d0854ee&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__